import { Language } from '../../../core/i18n/constants';
import { BASE_BACKEND_URL } from '../../backend/constants';
import { useAuthenticatedMutation } from '../../backend/hooks/use-authenticated-mutation';
import { AuthenticatedFormSendResponse, FormRequestBody } from '../../backend/openapi/api-types';

export const useAuthenticatedSendFormRequest = (currentLanguage: Language) => {
  const url = `${BASE_BACKEND_URL}/request-forms/send-form`;
  const mutationParams = {
    method: 'POST',
    url: url,
    language: currentLanguage,
  } as const;

  return useAuthenticatedMutation<AuthenticatedFormSendResponse, FormRequestBody>(mutationParams);
};
